import React from "react";
import { useAuth } from "../contexts/AuthContext";
import AdminDashboard from "./dashboards/AdminDashboard";
import AthleteDashboard from "./dashboards/AthleteDashboard";
import SupporterDashboard from "./dashboards/SupporterDashboard";
import SponsorDashboard from "./dashboards/SponsorDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="py-12 md:py-16" data-testid="dashboard-page">
      <div className="container-tight">
        <div className="overline">Signed in as {user.role}</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight mt-3 leading-[1.05]">
          Welcome back, <span className="text-primary">{user.name?.split(" ")[0]}</span>.
        </h1>
      </div>
      <div className="container-tight mt-10">
        {user.role === "admin" && <AdminDashboard />}
        {user.role === "athlete" && <AthleteDashboard />}
        {user.role === "supporter" && <SupporterDashboard />}
        {user.role === "sponsor" && <SponsorDashboard />}
      </div>
    </div>
  );
}
